<div class="bg-th-blue position-sticky top-0 mt-0 container-fluid py-2">
    <div class=" d-flex justify-content-between align-content-center">
        <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()"></i>

        <h4 class="text-white" *ngIf="Support">تعداد تیکت ها :{{Support.length}}</h4>
    </div>
</div>
<div class="d-flex col-12 justify-content-around dirI">
    <div class="col-md-3 col-12">
        <label>نوع</label>
        <select class="form-select" (change)="filterSubject($event.target)">
            <option value="-1">نمایش همه</option>
            <option *ngFor="let item of tiketSubject" value="{{item.tiTiketSubject}}">{{item.strComment}}</option>
        </select>
    </div>
    <div class="col-md-3 col-12">
        <label>وضعیت</label>

        <select class="form-select" (change)="filterStatus($event.target)">
            <option value="-1">نمایش همه</option>
            <option *ngFor="let item of tiketStatus" value="{{item.tiTiketStatus}}">{{item.strComment}}</option>

        </select>
    </div>
    <div class="col-md-3 col-12">
        <label>بر اساس شماره تیکت</label>
        <input type="text" class="form-control" (keyup)="baseOnId($event.target)">
    </div>

</div>
<div class="table-responsive dirI">
    <table class="table table-striped  border border-2 mt-1 rounded-3" style="max-width: 100%;" id="excel-table-support">
        <thead>
            <!-- [ngClass]="showLocation  ? 'index-1' : ''" -->
            <tr class=" " [ngClass]="deviceInfo  ? 'f14' : 'f10'">
                <th>#</th>

                <th class="pointer" (click)="sortById()">شماره</th>
                <th>وضعیت</th>
                <th>موضوع</th>
                <th>تاریخ ثبت </th>
                <th>تاریخ اعتبار </th>
                <th>موبایل راننده </th>
                <th>موبایل کاربر </th>
                <th class="pointer" (click)="sortByName()" class="pointer">نام کاربر</th>
                <th>کد دستگاه</th>

            </tr>
        </thead>
        <tbody>
            <tr class="pointer " [ngClass]="{'f14': deviceInfo === true, 'f10' : deviceInfo === false,'bg-smoke':item.tiTiketStatus==0,
            'bg-green-light':item.tiTiketStatus==1,
            'bg-purpel':item.tiTiketStatus==2,
            'bg-green-dark':item.tiTiketStatus==3,
            'bg-pink':item.tiTiketStatus==4,
            'bg-yellow':item.tiTiketStatus==5,
            'bg-blue-light':item.tiTiketStatus==6 }" *ngFor="let item of Support; index as i">
                <td>{{i+1|faNum}}</td>
                <td (click)="singel(i)" data-bs-toggle="modal" data-bs-target="#exampleModal2">{{item.iTiket}}</td>
                <td (click)="singel(i)" data-bs-toggle="modal" data-bs-target="#exampleModal2">{{item.strTiketStatus_strComment}}</td>
                <td (click)="singel(i)" data-bs-toggle="modal" data-bs-target="#exampleModal2">{{item.strTiketSubject_strComment}}</td>
                <td class="dirl" (click)="singel(i)" data-bs-toggle="modal" data-bs-target="#exampleModal2">{{item.strSaveDate}}</td>
                <td class="dirl" (click)="singel(i)" data-bs-toggle="modal" data-bs-target="#exampleModal2">{{item.strValidDate}}</td>
                <td class="dirl" (click)="singel(i)" data-bs-toggle="modal" data-bs-target="#exampleModal2">{{item.strMobile}}</td>
                <td class="dirl" (click)="singel(i)" data-bs-toggle="modal" data-bs-target="#exampleModal2">{{item.strSystemUser_strMobile}}</td>
                <td (click)="singel(i)" data-bs-toggle="modal" data-bs-target="#exampleModal2">{{item.strFullName}}</td>
                <td class="dirl" (click)="getDeviceInfo(item.strUnitID)" data-bs-toggle="modal" data-bs-target="#deviceInfo">{{item.strUnitID}}</td>

            </tr>

        </tbody>
    </table>

</div>


<div class="w-fit mx-auto   position-sticky bottom-0">
    <p class="text-center bg-th-blue rounded">
        <i title="خروجی اکسل" class="fa fa-file-excel-o pointer me-3 text-white fa-2x my-1" aria-hidden="true " (click)="exportexcel( 'excel-table-support') "></i>
    </p>

</div>


<!--اقدامات-->
<div class="modal fade rtl " id="exampleModal2" tabindex="-1" aria-labelledby="exampleModalLabel2" aria-hidden="true">
    <div class="modal-dialog modal-xl ">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel2">اقدامات</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="col-12 d-flex justify-content-between flex-wrap">
                <div class="col-md-5 col-11">
                    <p class="rtl d-flex  mx-3 mt-2" *ngIf="singelSupport"><span> شماره تیکت
                            :</span><span class="txt-navy">{{singelSupport.iTiket}}</span></p>
                </div>
                <div class="col-md-5 col-11">
                    <p class="rtl d-flex  mx-3 mt-2" *ngIf="singelSupport"><span> وضعیت تیکت
                            :</span><span class="txt-navy">{{singelSupport.strTiketStatus_strComment}}</span></p>
                </div>
                <div class="col-md-5 col-11">
                    <p class="rtl d-flex  mx-3 mt-2" *ngIf="singelSupport"><span> موضوع تیکت
                            :</span><span class="txt-navy">{{singelSupport.strTiketSubject_strComment}}</span></p>
                </div>
                <div class="col-md-5 col-11">
                    <p class="rtl d-flex  mx-3 mt-2" *ngIf="singelSupport"><span> زمان
                            :</span><span class="txt-navy">{{singelSupport.strSaveDate}}-{{singelSupport.strSaveTime}}</span></p>
                </div>
                <div class="col-md-5 col-11">
                    <p class="rtl d-flex  mx-3 mt-2" *ngIf="singelSupport"><span> توضیحات تیکت
                            :</span><span class="txt-navy">{{singelSupport.strDetail}}</span></p>
                </div>
            </div>

            <hr />

            <label class="mx-3 text-success">لیست اقدامات انجام شده </label>

            <div class="table-responsive col-10 mx-auto">
                <table class=" table table-striped dirI border border-2 mt-1 rounded-3 " style="max-width: 100%; ">
                    <thead>
                        <!-- [ngClass]="showLocation ? 'index-1' : '' " -->
                        <tr class="text-center " [ngClass]="deviceInfo ? 'f14' : 'f10' ">

                            <th>زمان</th>
                            <th>اقدام انجام شده </th>


                        </tr>
                    </thead>
                    <tbody>
                        <tr class="pointer text-center " [ngClass]="deviceInfo ? 'f14' : 'f10' " *ngFor="let item of Actions ">
                            <td>{{item.strDate}}-{{item.strTime}}</td>
                            <td>{{item.strActionDetail}}</td>


                        </tr>

                    </tbody>
                </table>

            </div>

            <hr />

            <div>

                <ng-container *ngIf="singelSupport && singelSupport.tiTiketStatus != 2 && singelSupport.tiTiketStatus != 5 && singelSupport.tiTiketStatus != 6">

                        <h5 class="ms-3 ">ثبت اقدام</h5>

                        <div class="col-10 mx-auto " [formGroup]="sabtModel">

                            <label class="label ">نوع اقدام</label>

                            <select class="form-select" formControlName="tiTiketStatus">

                                <option value="-1">انتخاب کنید</option>

                                <option *ngFor="let item of answerList " [value]="item.tiTiketStatus">
                                    
                                    {{item.strComment}}

                                </option>

                            </select>

                        </div>

                        <div class="col-12 d-flex justify-content-start flex-wrap " [formGroup]="sabtModel">

                            <div class="col-10 mx-auto my-3">
        
                                <textarea formControlName="strActionDetail" placeholder="متن پاسخ "
                                
                                        class="form-control mx-auto " id="exampleFormControlTextarea1 " rows="3 ">
                            
                                </textarea>
        
                            </div>
        
                        </div>

                </ng-container>

                <div class="col-12 d-flex justify-content-start flex-wrap " [formGroup]="sabtModel">

                    <div class="col-10 mx-auto my-3">

                        <textarea formControlName="strActionDetail" placeholder="متن پاسخ "
                        
                        class="form-control mx-auto " id="exampleFormControlTextarea1 " rows="3 ">
                    
                    </textarea>

                    </div>

                    <div class="col-12 d-flex mb-2 justify-content-end">

                        <button class="btn btn-success me-1 px-5"> 
                        
                            <a [routerLink]="['/carInfo',singelSupport?.strUnitID]"
                            
                                class="text-white" target="_blank">

                                مشخصات خودرو
                            
                            </a>
                        
                        </button>

                        <ng-container *ngIf="singelSupport && singelSupport.tiTiketStatus != 2 && singelSupport.tiTiketStatus != 5 && singelSupport.tiTiketStatus != 6">
                            
                            <button class="btn btn-primary me-1 px-5" (click)="sabt()"> ثبت </button>

                            <button class="btn btn-warning ms-1" data-bs-toggle="modal" data-bs-target="#SmsModal">

                                ارسال پیامک
    
                            </button>
    
                        </ng-container>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>

<!--ارسال پیامک-->

<div class="modal fade" id="SmsModal" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="btn-close " data-bs-dismiss="modal" aria-label="Close"></button>
                <h5 class="modal-title  ms-0" id="">ارسال پیامک</h5>
            </div>
            <div class="modal-body">
                <div class="col-10 mx-auto  dirI" [formGroup]="sendSmsModel">
                    <label>متن پیام</label>
                    <textarea formControlName="strMessage" formControlName="strMessage" placeholder="متن پبامک" class="form-control mx-auto " id="smsTxt" rows="3 "></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="sendSms()">ارسال پیام</button>
                <button type="button" class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#exampleModal2">برگشت</button>
            </div>
        </div>
    </div>
</div>

<!--اطلاعات دستگاه-->
<div class="modal fade" id="deviceInfo" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="btn-close " data-bs-dismiss="modal" aria-label="Close"></button>
                <h5 class="modal-title  ms-0" id="">اطلاعات دستگاه</h5>
            </div>
            <div class="modal-body">
                <div class="col-12 d-flex justify-content-between flex-wrap dirI" *ngIf="car">
                    <div class="col-6">
                        <p>وضعیت :
                            <br>
                            <span class="txt-navy">{{car.strDeviceStatus_strComment}}</span></p>
                    </div>
                    <div class="col-6">
                        <p>تاریخ و ساعت :
                            <br>
                            <span class="txt-navy">{{car.strDate}}_{{car.strTime}}</span></p>
                    </div>
                    <div class="col-6">
                        <p>نوع GPS :
                            <br>
                            <span class="txt-navy">{{car.strGPS_strComment}}</span></p>
                    </div>
                    <div class="col-6">
                        <p>شماره سیم کارت دستگاه :
                            <br>
                            <span class="txt-navy">{{car.strCellNo}}</span></p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>